import React from 'react';
import {useDashboard} from './context';
import type {Domain} from './types';

/** A clickable domain summary tile for the Portfolio grid. Ported verbatim from the prototype. */
export function DomainCard({domain, onClick}: {domain: Domain; onClick: (d: Domain) => void}): React.ReactElement {
  const {phases, phaseColors} = useDashboard();
  const phaseCounts: Record<string, number> = phases.reduce((a, p) => ({...a, [p]: 0}), {});
  domain.jtbds.forEach(j => {
    if (phaseCounts[j.phase] !== undefined) phaseCounts[j.phase]++;
  });
  const total = domain.jtbds.length;
  return (
    <div
      onClick={() => onClick(domain)}
      style={{
        background: '#fff',
        border: '1px solid #E2E8F0',
        borderRadius: 10,
        padding: '14px 16px',
        cursor: 'pointer',
        transition: 'box-shadow 0.15s',
        minWidth: 220
      }}
      onMouseEnter={e => (e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)')}
      onMouseLeave={e => (e.currentTarget.style.boxShadow = 'none')}
    >
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8}}>
        <div style={{fontWeight: 600, fontSize: 13, color: '#0F172A', lineHeight: 1.3, flex: 1, marginRight: 8}}>
          {domain.name}
        </div>
      </div>
      <div style={{fontSize: 11, color: '#64748B', marginBottom: 10}}>{domain.leader}</div>
      {/* Phase pills */}
      <div style={{display: 'flex', gap: 4, flexWrap: 'wrap'}}>
        {phases
          .filter(p => phaseCounts[p] > 0)
          .map(p => (
            <div key={p} style={{display: 'flex', alignItems: 'center', gap: 3}}>
              <div style={{width: 7, height: 7, borderRadius: '50%', background: phaseColors[p]?.dot}} />
              <span style={{fontSize: 10, color: '#64748B'}}>
                {phaseCounts[p]} {p}
              </span>
            </div>
          ))}
      </div>
      <div style={{marginTop: 8, fontSize: 10, color: '#94A3B8'}}>{total} JTBDs</div>
    </div>
  );
}
